import { Outlet, useParams } from 'react-router-dom'

import { DisplayFontsLoader } from '@/components/shared/DisplayFontsLoader'
import { useRecordRecentOpen } from '@/hooks/useRecordRecentOpen'

/** Mirrors layouts/TestResultsLayout/TestResultsLayout.tsx */
export function SpaResultsLayout() {
  const { id } = useParams<{ id: string }>()
  useRecordRecentOpen('experiment', id)

  return (
    <>
      <DisplayFontsLoader />
      <Outlet />
    </>
  )
}
